import BasePage from "@PrivateArea/Scripts/Pages/BasePage";

export default class AssetDetailPage extends BasePage {
    public static async init() {
        await super.init();

        this.setAssetProfileRelationList();
        this.setModal();
        this.selectTab();
        BasePage.updateAutospin();
    }

    private static setAssetProfileRelationList() {
        let assetShareButton = document.getElementById("AssetShareButton"),
            assetShareBox = document.getElementById("AssetShareBox"),
            body = document.getElementsByTagName("body")[0];

        if (assetShareButton) {
            assetShareButton.addEventListener("click", function () {
                if (assetShareBox && assetShareBox.classList.contains("hden")) {

                    if (!body.hasAttribute("data-overflow")) {
                        body.setAttribute("data-overflow", "");
                    }

                    assetShareBox.classList.remove("hden");
                }
            });
        }
    }

    private static setModal() {
        let gallery = document.getElementById("Gallery");
        if (gallery) {
            (<any>window).lightGallery(gallery, {
                download: false,
                thumbnail: true
            });
        }
    }

    private static selectTab() {
        document.querySelectorAll(".tablink").forEach(element => {
            element.addEventListener("click", event => {
                var section = element.getAttribute("data-type");
                const select = document.querySelector(".tablink[data-type='" + section + "']");

                document.querySelectorAll(".tabcontent").forEach(x => {
                    if (x.getAttribute("data-type") != section) {
                        x.classList.add("hden");
                    } else {
                        x.classList.remove("hden");
                    }
                });

                document.querySelectorAll(".tabcontent").forEach(x => { x.classList.remove("active"); });
                document.querySelectorAll(".tablink").forEach(x => { x.classList.remove("active"); });
                document.querySelector(".tabcontent[data-type='" + section + "']").classList.add("active");
                document.querySelector(".tablink[data-type='" + section + "']").classList.add("active");
            });
        });
    }
}